export default "<app-header></app-header>\r\n<app-topmenu></app-topmenu>\r\n<router-outlet></router-outlet>"